// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.editor_editor__container__ObCxU{
  position: relative;

  width: 100%;
  margin: 15px auto;
  margin-bottom: 0;

  text-align: left;

  color: #000;

  border: 1px solid #B2B5BB;
  border-radius: 0.25rem;
  background: #fff;

  font-weight: 400;
  line-height: 20px;
}

.editor_editor__inner__jQIRQ{
  position: relative;

  overflow: auto;

  min-height:160px;
  max-height: 300px;
  padding: 0;

  resize: vertical;

 
}

.editor_editor__input__\\+NEwY{
  position: relative;

  min-height: 150px;
  padding: 15px;

  cursor: text;

  tab-size: 1;

  outline: 0;

  caret-color: #444;
}

.editor_editorPreview__container__v\\+HDb {
  position: relative;

  width: 100%;
  margin: 5px auto;
  margin-bottom: 0;

  text-align: left;

  color: #000;
  background: #fff;

  font-weight: 400;
  line-height: 20px;
}

.editor_editorPreview__inner__TLI04 {
  position: relative;
}

.editor_editorPreview__input__xHBwH {
  position: relative;

  tab-size: 1;

  outline: 0;

  caret-color: #444;
}

`, "",{"version":3,"sources":["webpack://./src/components/CommentEditor/editor.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;;EAElB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;;EAEhB,gBAAgB;;EAEhB,WAAW;;EAEX,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;;EAEhB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,cAAc;;EAEd,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;;EAEV,gBAAgB;;;AAGlB;;AAEA;EACE,kBAAkB;;EAElB,iBAAiB;EACjB,aAAa;;EAEb,YAAY;;EAEZ,WAAW;;EAEX,UAAU;;EAEV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;;EAElB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;;EAEhB,gBAAgB;;EAEhB,WAAW;EACX,gBAAgB;;EAEhB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,WAAW;;EAEX,UAAU;;EAEV,iBAAiB;AACnB","sourcesContent":[".editor__container{\n  position: relative;\n\n  width: 100%;\n  margin: 15px auto;\n  margin-bottom: 0;\n\n  text-align: left;\n\n  color: #000;\n\n  border: 1px solid #B2B5BB;\n  border-radius: 0.25rem;\n  background: #fff;\n\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.editor__inner{\n  position: relative;\n\n  overflow: auto;\n\n  min-height:160px;\n  max-height: 300px;\n  padding: 0;\n\n  resize: vertical;\n\n \n}\n\n.editor__input{\n  position: relative;\n\n  min-height: 150px;\n  padding: 15px;\n\n  cursor: text;\n\n  tab-size: 1;\n\n  outline: 0;\n\n  caret-color: #444;\n}\n\n.editorPreview__container {\n  position: relative;\n\n  width: 100%;\n  margin: 5px auto;\n  margin-bottom: 0;\n\n  text-align: left;\n\n  color: #000;\n  background: #fff;\n\n  font-weight: 400;\n  line-height: 20px;\n}\n\n.editorPreview__inner {\n  position: relative;\n}\n\n.editorPreview__input {\n  position: relative;\n\n  tab-size: 1;\n\n  outline: 0;\n\n  caret-color: #444;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"editor__container": `editor_editor__container__ObCxU`,
	"editor__inner": `editor_editor__inner__jQIRQ`,
	"editor__input": `editor_editor__input__+NEwY`,
	"editorPreview__container": `editor_editorPreview__container__v+HDb`,
	"editorPreview__inner": `editor_editorPreview__inner__TLI04`,
	"editorPreview__input": `editor_editorPreview__input__xHBwH`
};
export default ___CSS_LOADER_EXPORT___;
